import { createFileRoute, redirect } from "@tanstack/react-router";

// `/admin/integrations/{kind}` opens that card's drawer on Integrations (spec 2.5). The Microsoft
// 365 admin-consent return lands here with `?email_consent=`, and Google's check with
// `?google_check=`; the page turns either into a toast.
export const Route = createFileRoute("/admin/integrations/$kind")({
  beforeLoad: ({ params, search }) => {
    const consent = (search as Record<string, unknown>).email_consent;
    const check = (search as Record<string, unknown>).google_check;
    throw redirect({
      to: "/admin/integrations",
      search: {
        open: params.kind,
        ...(typeof consent === "string" ? { email_consent: consent as never } : {}),
        ...(typeof check === "string" ? { google_check: check as never } : {}),
      },
      replace: true,
    });
  },
});
